import { combineReducers } from '@reduxjs/toolkit';

import authReducer from './reducers/auth';
import commonReducer from './reducers/common';
import searchReducer from './reducers/search';
import profileReducer from './reducers/profile';
import sidebarReducer from './reducers/sidebar';
import adminReducer from './reducers/admin';
import reducerTypes from './reducerTypes';

const appReducer = combineReducers({
    [reducerTypes.auth]: authReducer,
    [reducerTypes.common]: commonReducer,
    [reducerTypes.search]: searchReducer,
    [reducerTypes.profile]: profileReducer,
    [reducerTypes.sidebar]: sidebarReducer,
    [reducerTypes.admin]: adminReducer,
});
  
const rootReducer = (state, action) => {
    if (action.type === 'RESET_STORE') {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
